import { Component } from '@angular/core';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-exact-hire-section',
  templateUrl: './exact-hire-section.component.html',
  styleUrls: ['./exact-hire-section.component.scss'],
})
export class V2ExactHireSectionComponent {
  constructor(private bookDemo: BookDemoService) {}

  openBookDemo(): void {
    this.bookDemo.open();
  }
}
